import { render, staticRenderFns } from "./HeaderTextBlock.vue?vue&type=template&id=1ec76a05&"
import script from "./HeaderTextBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderTextBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports